<template>
  <header>
    <div class="container">
      <div class="logo">
        <a href="https://www.djoef.dk">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="85"
            height="41"
            viewBox="0 0 1080.000000 609.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0,609) scale(0.1,-0.1)"
              fill="#000000"
              stroke="none"
            >
              <path
                d="M9946 6079 c-384 -56 -694 -292 -832 -634 -74 -185 -94 -334 -94
                  -721 l0 -264 -210 0 -210 0 0 -305 0 -305 210 0 210 0 0 -1110 0 -1110 380 0
                  380 0 0 1110 0 1110 510 0 510 0 0 305 0 305 -510 0 -510 0 0 298 c0 314 5
                  353 50 447 35 72 104 141 178 177 59 29 77 33 169 36 82 3 124 0 199 -18 53
                  -12 98 -19 101 -17 3 3 34 108 69 234 36 125 73 259 84 296 l19 69 -52 23
                  c-67 29 -183 61 -274 74 -83 13 -291 12 -377 0z"
              />
              <path
                d="M0 3785 l0 -2156 953 4 c1036 4 995 1 1277 63 806 177 1389 718 1585
                  1470 56 217 69 328 70 609 0 266 -7 348 -46 530 -121 564 -448 1021 -938 1310
                  -190 113 -463 217 -691 265 -267 55 -235 53 -1257 57 l-953 4 0 -2156z m1848
                  1444 c770 -83 1263 -649 1262 -1447 -1 -665 -346 -1175 -923 -1367 -229 -76
                  -327 -85 -924 -85 l-493 0 0 1455 0 1455 490 0 c277 0 533 -5 588 -11z"
              />
              <path
                d="M7928 4453 l-117 -117 -108 51 c-422 198 -895 213 -1326 42 -194 -76
                  -337 -170 -490 -318 -206 -199 -328 -411 -397 -685 -102 -404 -41 -821 172
                  -1179 l22 -37 -107 -108 c-59 -59 -107 -112 -107 -117 0 -6 103 -114 230 -240
                  l230 -230 122 121 123 121 50 -28 c121 -69 346 -141 530 -170 103 -17 377 -17
                  480 0 356 56 643 198 880 436 200 199 327 430 389 705 58 261 43 571 -39 826
                  -26 78 -102 243 -146 317 l-23 37 112 113 112 112 -233 233 c-128 127 -234
                  232 -237 232 -3 0 -58 -53 -122 -117z m-729 -593 c46 -11 88 -23 93 -26 9 -6
                  -1058 -1084 -1073 -1084 -3 0 -15 37 -25 83 -27 118 -25 332 5 442 82 308 304
                  523 611 591 92 20 292 17 389 -6z m587 -597 c26 -107 26 -347 0 -448 -25 -95
                  -93 -237 -151 -313 -114 -151 -303 -259 -510 -293 -125 -20 -328 0 -424 42
                  -24 10 -1 34 515 550 296 296 542 539 545 539 3 0 15 -35 25 -77z"
              />
              <path
                d="M4290 2783 c0 -1073 -4 -1703 -10 -1748 -21 -144 -107 -268 -228
                  -327 -57 -28 -78 -33 -163 -36 -90 -4 -124 0 -285 35 -18 4 -26 -18 -102 -289
                  -46 -161 -82 -298 -82 -305 0 -11 50 -33 155 -66 186 -60 460 -63 680 -6 427
                  110 718 455 775 919 6 55 10 672 10 1792 l0 1708 -375 0 -375 0 0 -1677z"
              />
            </g>
          </svg>
        </a>
      </div>
      <div class="row">
        <div class="col-md-6 align-self-end">
          <h1 v-if="!isSuccess()">{{ $store.state.pageData.Title }}</h1>
          <h1 v-else>{{ $store.state.pageData.WelcomeTitle }}</h1>
        </div>
        <div class="col-6 d-none d-md-block">
          <AppHelpbox :data="$store.state.pageData.HelpBox" pos="text-right" />
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  import AppHelpbox from '@/components/base/AppHelpbox';
  export default {
    components: {
      AppHelpbox,
    },
    methods: {
      isSuccess() {
        return this.$route.path.includes('/step/success/');
      },
    },
  };
</script>
<style lang="scss" scoped>
  h1 {
    margin-top: 48px;
    margin-bottom: 0;
  }
  .logo {
    margin-top: 40px;
    margin-bottom: 10px;
    @include media-breakpoint-down(sm) {
      margin: 20px 0 10px;
    }
  }
</style>

